export enum IssueModalMode {
  Issue = 'issue',
  Edit = 'edit',
  Approve = 'approve',
}

interface IssueModalSettings {
  showTerms: boolean;
  /**
   * TODO: separate structuring validation and business validation. In approve mode and edit mode only business validation should be disabled.
   * shouldValidate is passed to issuance step for the same reason
   */
  shouldValidate: boolean;
  showAdminFields: boolean;
  applyIssuanceDefaults: boolean;
}

const settingsByMode: Record<IssueModalMode, IssueModalSettings> = {
  [IssueModalMode.Issue]: { showTerms: true, shouldValidate: true, showAdminFields: false, applyIssuanceDefaults: true },
  [IssueModalMode.Edit]: { showTerms: false, shouldValidate: false, showAdminFields: true, applyIssuanceDefaults: false },
  [IssueModalMode.Approve]: { showTerms: false, shouldValidate: false, showAdminFields: true, applyIssuanceDefaults: true },
};

export const getIssueModalSettings = (mode: IssueModalMode): IssueModalSettings => settingsByMode[mode];
